import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    key: 2,
    class: "q-pt-sm"
};
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-12" };
const _hoisted_4 = { class: "col-12" };
const _hoisted_5 = { class: "col-12" };
const _hoisted_6 = {
    key: 0,
    class: "col-12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_input = _resolveComponent("q-input");
    const _component_q_space = _resolveComponent("q-space");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_toolbar = _resolveComponent("q-toolbar");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_dialog = _resolveComponent("q-dialog");
    return (_openBlock(), _createElementBlock("div", null, [
        (_ctx.hint)
            ? (_openBlock(), _createBlock(_component_q_input, {
                key: 0,
                "model-value": _ctx.password,
                type: _ctx.isPwd ? 'password' : 'text',
                hint: !_ctx.password ? 'Password with uppercase, lowercase letters, special characters and numbers' : null,
                label: "Password",
                ref: "new_pw_with_hint",
                "data-cy": "new_pw_with_hint",
                outlined: "",
                clearable: "",
                name: "new-password",
                autocomplete: "new-password",
                "read-only": _ctx.readOnly,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (_ctx.passwordCheck$.next($event))),
                onFocus: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('focus', $event)))
            }, {
                append: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                        name: _ctx.isPwd ? 'visibility_off' : 'visibility',
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.isPwd = !_ctx.isPwd)),
                        class: "cursor-pointer"
                    }, null, 8, ["name"])
                ]),
                _: 1
            }, 8, ["model-value", "type", "hint", "read-only"]))
            : (_openBlock(), _createBlock(_component_q_input, {
                key: 1,
                "model-value": _ctx.password,
                type: _ctx.isPwd ? 'password' : 'text',
                label: "Password",
                ref: "new_pw_without_hint",
                "data-cy": "new_pw_without_hint",
                autocomplete: "new-password",
                name: "new-password",
                outlined: "",
                clearable: "",
                disable: _ctx.disable,
                "read-only": _ctx.readOnly,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (_ctx.passwordCheck$.next($event)))
            }, {
                append: _withCtx(() => [
                    _createVNode(_component_q_icon, {
                        name: _ctx.isPwd ? 'visibility_off' : 'visibility',
                        onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.isPwd = !_ctx.isPwd)),
                        class: "cursor-pointer"
                    }, null, 8, ["name"])
                ]),
                _: 1
            }, 8, ["model-value", "type", "disable", "read-only"])),
        (_ctx.checkPwd && _ctx.password)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_q_icon, {
                            name: (_ctx.checkPwd.score < 43) ? 'highlight_off' : 'check_circle',
                            color: (_ctx.checkPwd.score < 43) ? 'negative' : 'positive'
                        }, null, 8, ["name", "color"]),
                        _createElementVNode("span", {
                            class: _normalizeClass({ 'text-positive': (_ctx.checkPwd.score >= 43), 'text-negative': (_ctx.checkPwd.score < 43) })
                        }, [
                            _cache[7] || (_cache[7] = _createTextVNode(" Password Strength: ")),
                            _createElementVNode("span", {
                                class: _normalizeClass(`text-${_ctx.checkPwd.color}`)
                            }, _toDisplayString(_ctx.checkPwd.strength), 3)
                        ], 2)
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_q_icon, {
                            name: (_ctx.checkPwd.matchLength < 8) ? 'highlight_off' : 'check_circle',
                            color: (_ctx.checkPwd.matchLength < 8) ? 'negative' : 'positive'
                        }, null, 8, ["name", "color"]),
                        _createElementVNode("span", {
                            class: _normalizeClass({ 'text-positive': (_ctx.checkPwd.matchLength >= 8), 'text-negative': (_ctx.checkPwd.matchLength < 8) })
                        }, " At least 8 Characters ", 2)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                        _createVNode(_component_q_icon, {
                            name: _ctx.checkPwd.matchSpecialChar || _ctx.checkPwd.matchNumber ? 'check_circle' : 'highlight_off',
                            color: _ctx.checkPwd.matchSpecialChar || _ctx.checkPwd.matchNumber ? 'positive' : 'negative'
                        }, null, 8, ["name", "color"]),
                        _createElementVNode("span", {
                            class: _normalizeClass({ 'text-negative': !_ctx.checkPwd.matchSpecialChar && !_ctx.checkPwd.matchNumber, 'text-positive': _ctx.checkPwd.matchSpecialChar || _ctx.checkPwd.matchNumber })
                        }, " Contains Number or Symbol ", 2)
                    ]),
                    (!_ctx.removeNameRequirement)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_q_icon, {
                                name: _ctx.checkPwd.noMatchName ? 'check_circle' : 'highlight_off',
                                color: _ctx.checkPwd.noMatchName ? 'positive' : 'negative'
                            }, null, 8, ["name", "color"]),
                            _createElementVNode("span", {
                                class: _normalizeClass({ 'text-negative': !_ctx.checkPwd.noMatchName, 'text-positive': _ctx.checkPwd.noMatchName })
                            }, " Does Not Contain Your Name or Email ", 2)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]))
            : _createCommentVNode("", true),
        _createVNode(_component_q_dialog, {
            modelValue: _ctx.showStrong,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.showStrong) = $event))
        }, {
            default: _withCtx(() => [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_toolbar, { class: "bg-primary text-white" }, {
                            default: _withCtx(() => [
                                _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-h6" }, "Passwords", -1)),
                                _createVNode(_component_q_space),
                                _createVNode(_component_q_btn, {
                                    flat: "",
                                    round: "",
                                    icon: "close",
                                    onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.showStrong = false))
                                })
                            ]),
                            _: 1,
                            __: [8]
                        }),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => _cache[9] || (_cache[9] = [
                                _createElementVNode("span", { class: "text-subtitle2" }, "As your account may contain sensitive information, it is recommended that you set a strong password to safeguard your account", -1)
                            ])),
                            _: 1,
                            __: [9]
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => _cache[10] || (_cache[10] = [
                                _createElementVNode("span", { class: "text-h6" }, "What makes a password strong?", -1)
                            ])),
                            _: 1,
                            __: [10]
                        }),
                        _createVNode(_component_q_card_section, { class: "text-subtitle2" }, {
                            default: _withCtx(() => _cache[11] || (_cache[11] = [
                                _createElementVNode("span", null, "A strong password consists of the following criterias:", -1),
                                _createElementVNode("ul", { class: "q-pl-md" }, [
                                    _createElementVNode("li", null, "More than 8 characters"),
                                    _createElementVNode("li", null, "Has a mixture of upper and lowercase letters"),
                                    _createElementVNode("li", null, "Contains symbol(s) like '!*#'"),
                                    _createElementVNode("li", null, "Does not contain your pubilicly accessible information like name, email address, phone number and d.o.b"),
                                    _createElementVNode("li", null, "Does not contain words like 'password'")
                                ], -1)
                            ])),
                            _: 1,
                            __: [11]
                        })
                    ]),
                    _: 1
                })
            ]),
            _: 1
        }, 8, ["modelValue"])
    ]));
}
